import {
    Body1Stronger, Button, Card,
    CardFooter, CardHeader, CardPreview,
    CounterBadge, Image, makeStyles,
    shorthands,
    tokens,
    typographyStyles,
} from "@fluentui/react-components";

import { Delete32Regular, Open32Regular } from "@fluentui/react-icons";
import { Count, Archive } from "../../library/CosmeWidgetAPIClient";
import { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CWClientContext } from "../../App";

const useStyles = makeStyles({
    cardHeader: {
        ...typographyStyles.subtitle2Stronger,
    },
    card: {
        // ...shorthands.margin("4px 4px 12px 12px"),
        marginTop: tokens.spacingVerticalXL,
        ...shorthands.borderRadius("12px"),
        // boxShadow: getTheme().effects.elevation8,
        maxWidth: "18vw",
        minHeight: "280px",
        ...shorthands.borderColor("pink"),
        avoidBreak: "all",
        boxShadow: tokens.shadow4 ,
    },
    preview: {
    },
    image: {
        ...shorthands.marginBlock("1px", "5px"),
    },
    title: {
        ...shorthands.margin("4px 4px 4px 0"),
        ...shorthands.overflow("hidden"),
    }

});



export type ExtractCardProp = {
    archive: Archive;
    count?: Count;
}

function ArchiveCard(prop: ExtractCardProp) {
    const cwClient = useContext(CWClientContext);
    const styles = useStyles();
    const [visible, setVisible] = useState(true);
    const location = useLocation();


    const ignoreArchive = function (url: string, archivePath: string) {
        cwClient.ignoreArchive(url, archivePath);
        setVisible(false);
    }
    const cardPreview = function () {
        if (prop.archive.ogp?.image == null) {
            return (
                <CardPreview className={styles.preview}>
                    <Body1Stronger className={styles.title}>
                        {prop.archive.pageTitle}
                    </Body1Stronger>
                </CardPreview>

            );
        } else {
            return (
                <CardPreview className={styles.preview}>
                    <Body1Stronger className={styles.title}>
                        {prop.archive.pageTitle}
                    </Body1Stronger>

                    <Image
                        className={styles.image}
                        src={prop.archive.ogp?.image}
                        alt={prop.archive.pageTitle}
                        fit="cover"
                    />
                </CardPreview>
            );
        }
    }
    let d: Date = new Date(prop.archive.saved);
    let date: string = d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate();
    if (visible) {
        return (
            <>
                <div className="ms-Grid-col ms-sm4 ms-xl4">
                    <Card className={styles.card} >
                        <CardHeader
                            className={styles.cardHeader}
                            header={
                                date
                            }
                        />
                        {cardPreview()}
                        <a target="brank" href={prop.archive.url}>{prop.archive.url}</a>
                        <CardFooter>
                            <Button icon={<Delete32Regular />}
                                onClick={() => { ignoreArchive(prop.archive.url, prop.archive.archivePath) }}
                            >
                                無視
                            </Button>
                            <Link to={"/extract/a/" + prop.archive.id}

                            >
                                <Button icon={<Open32Regular />}
                                    onClick={() => { location.pathname = "/extract/a/" + prop.archive.id }}
                                >詳細
                                    <CounterBadge>{prop.count?.count}</CounterBadge>
                                </Button>
                            </Link>

                        </CardFooter>
                    </Card >
                </div >
            </>
        );
    } else {
        return (<></>);
    }

}

export default ArchiveCard;